import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MessageService} from 'primeng/api';
import {I18NextService} from 'angular-i18next';
import {PortNumberBlockDetails, PortNumbersPortingFormDetails} from "../../port-phonenumber.model";

export enum PortSteps {
  'select_provider',
  'select_phone_numbers',
}

@Component({
    selector: 'app-phonenumber-port-at',
    templateUrl: './phonenumber-port-at.component.html',
    standalone: false
})
export class PhonenumberPortAtComponent implements OnInit {

  public step: PortSteps;
  public formDetails: PortNumbersPortingFormDetails;

  public countryCode = 'AT';
  public trunkPrefix = '0043';

  @Output()
  public selected = new EventEmitter<PortNumbersPortingFormDetails>();

  @Output() 
  public onBack: EventEmitter<void> = new EventEmitter<void>();

  constructor(public messageService: MessageService,
              public i18next: I18NextService) {
  }

  ngOnInit(): void {
    this.formDetails = new PortNumbersPortingFormDetails();
    this.step = 0;
  }

  next() {
    ++this.step;
  }

  stepBack() {
    --this.step;
  }

  back() {
    this.onBack.emit();
  }

  onProviderSelected(providerName: string) {
    this.formDetails.provider = providerName;
    this.next();
  }

  onSelectNumbersToPortComplete(numbers: PortNumberBlockDetails[]) {
    this.formDetails.numbers = numbers;
    this.selected.emit(this.formDetails);
  }

  public get portSteps() {
    return PortSteps;
  }

}
